module.exports = __webpack_public_path__ + "static/media/agricultural4.2132eb23.jpg";